import { store, type Store } from './store';
import { useStore as useZustandStore } from 'zustand';

export const useStore = <T>(selector: (state: Store) => T) =>
    useZustandStore(store, selector);